
import HeaderSession from "../../../../utils/headerSession";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import api from "../../../../services/api";
import Loading from "../../../../load/loading";
import CardInspeccao from "./avfd/cardInspeccao";
import RegisterAccess from "../../../../utils/registerAccess";
import FichaEstabelecimento from "../../../gestLicenciados/fichaEstabelecimento";
import { Card, MenuItem, TextField } from "@mui/material";
import ListaVazia from "../../../../utils/listaVazia";
import InspeccaoRealizada from "./avfd/inspeccaoRealizada";
import FichaDirectorTecnico from "../../../gestDirectorTecnico/fichaDirectorTecnico";
import { useSearchParams } from "react-router-dom";
import Paginacao from "../../../../utils/paginacao";
import ButtonLeft from "../../../../utils/buttonLeft";

export default function InspeccaoByInspector({ element: component, ...rest }) {
    const user = useSelector(state => state.account.user);
    const [inspeccoes, setInspeccoes] = useState('');
    const [status, setStatus] = useState('Não Realizada');
    const [configLista, setConfigLista] = useState('');
    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get("page"));
    const [perPage, setPerPage] = useState(20);

    const [directorTecnico, setDirectorTecnico] = useState(false);

    useEffect(() => {
        // api.get(`/inspeccaos`)
        setInspeccoes('')
        api.get(`/inspeccaos?inspectorId=${'66df5e733fadbecde1744c84'}&status=${status}&perPage=${perPage}&page=${page}`)
            // api.get(`/inspeccaos?inspectorId=${user._id}&status=${status}&perPage=${perPage}&page=${page}`)
            .then(response => {
                // console.log(response)
                setInspeccoes(response.data.inspeccaos);
                setConfigLista(response.data);
            }).catch(err => 'console.log(err)')
    }, [user._id, status, page, perPage]);

    return (
        <div className="tw-mx-auto tw-w-full tw-max-w-5xl tw-space-y-4 tw-p-2 md:tw-p-3">
            <RegisterAccess page={'ver inspeccao por inspector'} />
            <HeaderSession title={'MINHAS INSPECÇÕES'} />

            <section className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 tw-shadow-sm">
                <div className="tw-flex tw-flex-wrap tw-items-end tw-justify-between tw-gap-3">
                    <div>
                        <p className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500">Filtro</p>
                        <h3 className="tw-text-base tw-font-bold tw-text-slate-900">Estado da Inspecção</h3>
                    </div>

                    <div className="tw-flex tw-items-center tw-gap-3">
                        <TextField
                            type="text"
                            select
                            size="small"
                            variant="outlined"
                            value={status || 'Geral'}
                            onChange={(e) => { setStatus(e.target.value === 'Geral' ? '' : e.target.value) }}
                            sx={{ minWidth: 220 }}
                        >
                            <MenuItem key='Não Realizada' value='Não Realizada'>
                                Não Realizada
                            </MenuItem>
                            <MenuItem key='Realizada' value='Realizada'>
                                Realizada
                            </MenuItem>
                            <MenuItem key='Reprovada' value='Reprovada'>
                                Reprovada
                            </MenuItem>
                            <MenuItem key='Geral' value='Geral'>
                                Geral
                            </MenuItem>
                        </TextField>

                        {Array.isArray(inspeccoes) && (
                            <span className="tw-inline-flex tw-items-center tw-rounded-xl tw-bg-slate-100 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700">
                                {inspeccoes.length} resultado(s)
                            </span>
                        )}
                    </div>
                </div>
            </section>

            {inspeccoes ?
                <>
                    {
                        inspeccoes.map((inspeccao, index) =>
                            inspeccao.status === 'Realizada' ?
                                <InspeccaoRealizada key={inspeccao._id} inspeccaoId={inspeccao._id} />
                                :
                                <Card key={inspeccao._id} className="tw-mb-6 tw-overflow-hidden tw-rounded-2xl tw-border tw-border-slate-200 tw-shadow-sm">
                                    <CardInspeccao thisInspeccao={inspeccao} />
                                    <FichaEstabelecimento menu={false} estabelecimento={inspeccao?.estabelecimento} />
                                    {directorTecnico === inspeccao?._id ?
                                        <FichaDirectorTecnico header={true} menu={false} directorTecnico={inspeccao?.estabelecimento?.directorTecnico} />
                                        :
                                        <ButtonLeft title={'Ver Director Técnico'} funcao={() => { setDirectorTecnico(inspeccao?._id) }} />
                                    }

                                </Card>
                        )}
                    <Card className="tw-rounded-2xl tw-border tw-border-slate-200 tw-shadow-sm">
                        <Paginacao
                            configLista={configLista}
                            lista={inspeccoes}
                            page={page}
                            setPage={setPage}
                            setPerPage={setPerPage}
                        // setOrder={setOrder}
                        />
                    </Card>
                </>
                :
                <div className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-5 tw-shadow-sm">
                    <Loading text={'A carregar inspecções'} focus={false} />
                </div>
            }

            {inspeccoes && inspeccoes.length < 1 && <ListaVazia text={'Nenhuma inspecção encontrada.!'} />}
        </div>
    )
}